<template>
  <TableBody
    :isInfinite="isInfinite"
    :items="items"
    class="gw_table_small table-combos tblcombos"
    @mouseleave="setHiglight(null)"
  >
    <template #head_sticky>
      <TableHead
        :sortConf="tbl_sortConf"
        :thead="thead"
        class="large-scroll-track"
        @click:th="tbl_handleSort"
      />
    </template>
    <template #default="{ item, index }">
      <CombosTableRowOpponent
        :player="player"
        :thead="thead"
        :item="item"
        :index="index"
        :showFlopContent="showFlopContent"
        :bettingInfo
        @mouseenter="setHiglight(item)"
        @click="setHiglight(item)"
      >
      </CombosTableRowOpponent>
    </template>
  </TableBody>
</template>

<script>
import TableHead from '@/components/DataTables/v2/TableHead'
import TableBody from '@/components/DataTables/v2/TableBody'
import CombosTableRowOpponent from '@/components/DataTables/v2/tables/CombosTable/CombosTableRowOpponent'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import tier_mix from '@/mixins/tier_mix'
import format_mix from '@/mixins/format_mix'
import { throttle } from 'lodash'

export default {
  name: 'CombosTableOpponent',
  components: {
    TableHead,
    TableBody,
    CombosTableRowOpponent,
  },
  mixins: [table_mix, float_mix, tier_mix, format_mix],
  props: {
    isInfinite: { type: Boolean, default: true },
    player: String,
    tableGroups: { default: () => [] },
    showAllCombos: Boolean,
    showGroupCombos: Boolean,
    opponentGroup: Object,
    mobile: Boolean,
    showFlopContent: Boolean,
    tableMouseover: Boolean,
    bettingInfo: Object,
  },
  emits: ['combo:mouseenter'],
  data() {
    this.tbl_persistSortKey = 'sort_combos_table_opponent'
    this.l_sortConf = {
      sortKey: 'summary_idx',
      sortOrder: 'desc',
    }
    return {
      tbl_sortConf: this.l_sortConf,
    }
  },
  methods: {
    setHiglight: throttle(function (hand) {
      this.$emit('combo:mouseenter', hand)
    }, 40),
    getSortedItems(items) {
      const res = items.map(i => i)
      const { sortKey, sortOrder } = this.tbl_sortConf
      const l_sortOrder = this.thead[sortKey].reverseSort
        ? sortOrder === 'desc'
          ? 'asc'
          : 'desc'
        : sortOrder
      //   let l_sortOrder = sortOrder
      const aVal = l_sortOrder === 'desc' ? -1 : 1
      const bVal = l_sortOrder === 'desc' ? 1 : -1
      if (sortKey === 'summary_idx') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? aVal : bVal))
      } else {
        res.sort((a, b) =>
          a.players[this.player][sortKey] > b.players[this.player][sortKey] ? aVal : bVal,
        )
      }
      return res
    },
  },
  computed: {
    allItems() {
      let res = this.tableGroups.reduce(
        (a, b) => [...a, ...b.combos.filter(i => i.players[this.player].range)],
        [],
      )
      res = this.getSortedItems(res)
      return res
    },
    comboItems() {
      const res = this.getSortedItems(
        (this.opponentGroup?.combos || []).filter(i => i.players[this.player].range),
      )
      return res
    },
    items() {
      if (this.showAllCombos) {
        return this.allItems
      }
      if (this.showGroupCombos) {
        return this.comboItems
      }
      return this.tableMouseover ? this.comboItems : this.allItems
    },
    thead() {
      const styles = {
        cssStyle: '--min-width-th: 5rem; --max-width-th: 5rem',
        tdStyle: '--min-width-td: 5rem; --max-width-td: 5rem',
      }
      return {
        summary_idx: {
          name: this.$t('table_head.hand'),
          sortKey: 'summary_idx',
          reverseSort: true,
          cssClass: 'gw_table_head_cell_sticky',
          cssStyle: '--min-width-th: 5rem; --max-width-th: 5rem',
          tdStyle: '--min-width-td: 5rem; --max-width-td: 5rem',
        },
        range: {
          name: this.$t('table_head.range'),
          sortKey: 'range',
          ...styles,
        },
        ev: {
          name: this.getEvUnitHtml({ ...this.bettingInfo, player: '1' }),
          sortKey: 'ev',
          ...styles,
        },
        eq: {
          name: this.$t('table_head.eq_percent'),
          ...(this.showFlopContent ? { sortKey: 'eq' } : {}),
          ...styles,
        },
        eqr: {
          name: this.$t('table_head.eqr_percent'),
          ...(this.showFlopContent ? { sortKey: 'eqr' } : {}),
          ...styles,
        },
      }
    },
  },
  watch: {
    thead: {
      immediate: true,
      handler: 'tbl_setSortConf',
    },
  },
}
</script>

<style lang="scss" scoped>
.tblcombos {
  &_prefloponlytag {
    position: absolute;
    z-index: 4;
    top: 1.125em;
    left: 27em;
  }
  &_premiumbtn {
    position: absolute;
    z-index: 4;
    top: 1.125em;
    left: 38em;
    width: 9em;
  }
}

@media screen and (max-width: 1700px) {
  .tblcombos {
    &_prefloponlytag {
      left: 24em;
    }
    &_premiumbtn {
      left: 35em;
    }
  }
}
</style>
